import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import WhyNeedSection from './components/WhyNeedSection';
import CTASection from './components/CTASection';
import HowWeWorkSection from './components/HowWeWorkSection';
import PricingSection from './components/PricingSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import BenefitsSection from './components/BenefitsSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const openForm = () => setIsContactFormOpen(true);

  return (
    <div className="bg-[#F9FAFB]">
      <Header onOpenContactForm={openForm} />

      <HeroBanner />

      <WhyNeedSection onOpenContactForm={openForm} />

      <HowWeWorkSection />

      <CTASection
        onOpenContactForm={openForm}
        heading="Stop Waiting. File Your Trademark Now."
        paragraph="Every day you delay is another day your brand is exposed. Our attorneys file with the USPTO and get it done — starting at $45. No excuses."
        buttonText="Protect My Brand Now"
        backgroundImage="https://images.unsplash.com/photo-1688748807457-d8926e351596?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGxpZ2h0JTIwd2F2ZXMlMjB0ZXh0dXJlJTIwd2hpdGV8ZW58MHx8fHwxNzc2Mjg5ODk1fDA&ixlib=rb-4.1.0&q=85"
      />

      <PricingSection onOpenContactForm={openForm} />

      <WhyChooseUsSection onOpenContactForm={openForm} />

      <BenefitsSection />

      <CTASection
        onOpenContactForm={openForm}
        heading="Your Competitors Already Filed. Have You?"
        paragraph="Trademark Agency USA is the only way to legally own your brand across all 50 states. The longer you wait, the more exposed you are."
        buttonText="Register My Trademark"
        backgroundImage="https://images.unsplash.com/photo-1619252584172-a83a949b6efd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGxpZ2h0JTIwd2F2ZXMlMjB0ZXh0dXJlJTIwd2hpdGV8ZW58MHx8fHwxNzc2Mjg5ODk1fDA&ixlib=rb-4.1.0&q=85"
      />

      <TestimonialsSection />

      <FAQSection />

      <Footer onOpenContactForm={openForm} />

      <ContactFormDialog
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
      />

      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
